import { Close } from "assets/icons/Common";
import styled from "styled-components";

import { Col, HorizontalLine, IconButton } from "./primitives";
import { AllWidgetTypes } from "./widgets";

interface Props {
  isOpen: boolean;
  widgetTypeId?: string;
  widgetSettings?: {
    [id: string]: any;
  };
  widgetState?: { [id: string]: any };
  updateSetting?: (setting: string, data: any) => void;
  closeSettings: () => void;
}

export const SettingsBar: React.FC<Props> = ({
  isOpen,
  widgetTypeId,
  widgetSettings,
  widgetState,
  updateSetting = (d: any) => {},
  closeSettings,
}) => {
  const widgetType = widgetTypeId ? AllWidgetTypes[widgetTypeId] : undefined;
  const Icon = widgetType?.icon;
  return (
    <SettingsSidebar aria-expanded={isOpen}>
      {widgetType && (
        <InnerContainer>
          <CloseButton Icon={Close} onClick={closeSettings} />
          <SettingsHeader>
            {Icon && <Icon width="40px" />}
            <p>{widgetType.name}</p>
          </SettingsHeader>
          <SettingsContainer>
            <HorizontalLine margin="0.5em 0em" />
            {widgetSettings && Object.entries(widgetType.settings).length ? (
              Object.entries(widgetType.settings).map(([settingId, { editor: Editor, info }]) => (
                <Editor
                  key={settingId}
                  info={info}
                  data={widgetSettings[settingId]}
                  setData={updateSetting?.bind(null, settingId)}
                  state={widgetState || {}}
                  settings={widgetSettings}
                  updateAnyWidgetSetting={updateSetting}
                />
              ))
            ) : (
              <p>No Settings Yet</p>
            )}
          </SettingsContainer>
        </InnerContainer>
      )}
    </SettingsSidebar>
  );
};

const SettingsSidebar = styled.div`
  --sidebar-width: 20rem;
  position: fixed;
  height: 100dvh;
  width: var(--sidebar-width);
  z-index: 6000;
  right: calc(var(--sidebar-width) * -1 - 50px);
  container-type: size;
  container-name: settings-bar;
  background-color: white;
  box-shadow: 0px 0px 3px 0px;

  transition: right 300ms ease;

  border-left: thin solid black;

  &[aria-expanded="true"] {
    right: 0;
  }
`;

const InnerContainer = styled(Col).attrs({ className: "px-3" })`
  align-items: center;
  position: relative;
  height: 100%;
`;

const SettingsHeaderHeight = "4rem";

const SettingsHeader = styled.div.attrs({ className: "p-2" })`
  height: ${SettingsHeaderHeight};
  display: flex;
  flex-direction: row;
  color: var(--secondary);
  align-items: center;
  justify-content: center;
  gap: 10px;
  p {
    font-weight: 600;
    font-size: 18px;
  }
`;

const SettingsContainer = styled(Col)`
  height: calc(100% - ${SettingsHeaderHeight});
  overflow-y: auto;
  width: 100%;
  padding: 0px 8px;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  left: 0;
  top: 15px;
  width: 32px;
  transform: translate(-50%, 0);
  padding: 8px;
`;
